const initNav = () => {
  document.addEventListener('click', e => {
    if (
      e.target.matches('.mobile-navigation-toggle') ||
      e.target.matches('.mobile-navigation-close')
    ) {
      document.querySelector('body').classList.toggle('nav-open');
    }
  });
};

document.addEventListener('DOMContentLoaded', () => {
  initNav();
});
